// extracted by mini-css-extract-plugin
export default {"actions":"SurveyDetailsFilters_actions__lGz52","placeHolderShimmer":"SurveyDetailsFilters_placeHolderShimmer__zfZdt"};